import React from 'react';
import { TypographyProps } from '@vtblife/uikit/dist/components/typography/types';

import classname from '@search/classname/src';
import { OfferRoute } from '../../../types/OfferRoute';
import { OfferRouteCard } from '../OfferRouteCard';
import { OfferRoutePopupList } from '../OfferRoutePopupList';

import './style.css';

interface OfferRouteSnippetProps {
    offerRoutes: OfferRoute[];
    size?: TypographyProps['variant'];
    isClSnippet?: boolean;
}

const cnSnippet = classname.bind(null, 'OfferRouteSnippet');

export const OfferRouteSnippet = React.memo(({ offerRoutes, size, isClSnippet }: OfferRouteSnippetProps) => {
    const offerRoute = offerRoutes.length > 0 ? offerRoutes[0] : null;

    return (
        <div className={cnSnippet()}>
            {offerRoute ? <OfferRouteCard
                variant={size}
                offerRoute={offerRoute}
            /> : null}
            {
                offerRoutes.length > 1 ?
                    <OfferRoutePopupList
                        offerRoutes={offerRoutes.slice(1)}
                        className={cnSnippet('list')}
                        isClSnippet={isClSnippet}
                    /> :
                    null
            }
        </div>
    );
});
